import { getLoaderEndpoint } from "@app/framework/loader";
import { pageHead } from "@app/framework/meta";
import { GeneralAssemblyPage } from "@modules/general-assembly/pages";
import { getGeneralAssemblyService } from "@modules/general-assembly/services";
import { trans } from "@mongez/localization";
import { LoaderFunctionArgs, MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export async function loader({ request }: LoaderFunctionArgs) {
  const { http, success, catchErrors } = await getLoaderEndpoint(request);

  try {
    const response = await getGeneralAssemblyService(http);

    return success(response);
  } catch (error) {
    return catchErrors(error);
  }
}

export default function GeneralAssembly() {
  useLoaderData();

  return <GeneralAssemblyPage />;
}

export const meta: MetaFunction = () => {
  return pageHead({
    title: trans("generalAssembly"),
    appendAppName: true,
  });
};
